module.exports = __webpack_public_path__ + "media/images/emblems/Evilard-coat_of_arms-4151a067090d43b0585562ee3aada3b7.svg";